/**
 * Recebe uma data americana e retorna no formato BR
 * @param {String} date Uma data no formato YYYY-MM-DD
 * @returns {String} Uma data no formato DD/MM/YYYY
 */
export const formatDateToBr = date => {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}

export const formatDateToEn = date => {
  if (!date) return null
  const [day, month, year] = date.split('/')
  return `${year}-${month}-${day}`
}

export const validateDate = date => {
  if (!date) return false
  var data = date
  var dia = data.substring(0, 2)
  var mes = data.substring(3, 5)
  var ano = data.substring(6, 10)

  var novaData = new Date(ano, (mes - 1), dia)

  var mesmoDia = parseInt(dia, 10) === parseInt(novaData.getDate())
  var mesmoMes = parseInt(mes, 10) === parseInt(novaData.getMonth()) + 1
  var mesmoAno = parseInt(ano) === parseInt(novaData.getFullYear())

  if (!((mesmoDia) && (mesmoMes) && (mesmoAno))) {
    return false
  }
  return true
}
